import http from '@/plugins/api'
import { startLoading } from '@/plugins/loading'
import * as types from './types'

export default {
  setSearchTerm({ commit }, text) {
    commit(types.SET_SEARCH_TERM, text)
  },
  setPageSize({ commit }, pageSize) {
    commit(types.SET_PAGE_SIZE, pageSize)
  },
  setRetrospectiveDay({ commit }, days) {
    commit(types.SET_DAYS, days)
  },
  setSortDir({ commit }, sortDir) {
    commit(types.SET_SORT_DIR, sortDir)
  },
  setOrderBy({ commit }, orderBy) {
    commit(types.SET_ORDER_BY, orderBy)
  },
  filterWorkOrderQueue({ commit }, filterBy) {
    commit(types.FILTER_WORKORDER_QUEUE, filterBy)
  },
  filterTechQueue({ commit }, filterBy) {
    commit(types.FILTER_TECH_QUEUE, filterBy)
  },
  filterToolQueue({ commit }, filterBy) {
    commit(types.FILTER_TOOL_QUEUE, filterBy)
  },
  async getWorkOrderQueue({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getWorkOrderQueue', () =>
      http.get(`dispatch/WorkOrderQueue?from=0&includeScheduled=true`)
    )
    commit(types.SET_WORKORDER_QUEUE, r.data)
  },
  async getTechQueue({ commit, dispatch }, searchOptions, id) {
    const r = await startLoading(dispatch, 'getTechQueue', () =>
      http.get(`dispatch/TechQueue`)
    )
    commit(types.SET_TECH_QUEUE, r.data)
  },
  async getToolQueue({ commit, dispatch }, searchOptions, id) {
    const r = await startLoading(dispatch, 'getToolQueue', () =>
      http.get(`dispatch/ToolQueue`)
    )
    commit(types.SET_TOOL_QUEUE, r.data)
  },
  async getQueue({ commit, dispatch }, status) {
    const r = await startLoading(dispatch, 'getQueue', () =>
      http.get(`dispatch/Queue?status=${status}`)
    )
    commit(types.SET_QUEUE, r.data)
  },
  async getDispatchLog({ commit, dispatch }, searchOptions, id) {
    const r = await startLoading(dispatch, 'getDispatchLog', () =>
      http.get(`dispatch/GetLog`, {
        params: searchOptions
      })
    )
    commit(types.SET_DISPATCH_LOG, r.data)
  },
  async getBreakdownSummary({ commit, dispatch }, view) {
    const r = await startLoading(dispatch, 'getBreakdownSummary', () =>
      http.get(`admin/workorder/breakdown/summary/${view}`)
    )
    commit(types.SET_BREAKDOWN_SUMMARY, r.data)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/dispatch/actions.js